import React from "react";
import ReactDOM from "react-dom";
import App from "./app/App.tsx";
import reportWebVitals from "./reportWebVitals";
import {Provider} from "react-redux";
import {store} from "./store/store";
import {BrowserRouter as Router} from "react-router-dom"

ReactDOM.render(
    <>
        <Provider store={store}>
            <Router>
                <App/>
            </Router>
        </Provider>
    </>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
